module.exports = __webpack_public_path__ + "assets/img/question-mark.899a46ec.svg";